import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ETimelineGroup } from 'src/app/project/modules/preferences/preferences.model';

import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PreferencesService } from 'src/app/project/modules/preferences/preferences-service/preferences.service';
import { CustomTableService } from '../../site-table/custom-table/custom-table.service';
import { TimelineGroupService } from '../timeline-group.service';

@Component({
  selector: 'pp-timeline-grouping-dropdown',
  templateUrl: './timeline-grouping-dropdown.component.html',
  styleUrls: ['./timeline-grouping-dropdown.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineGroupingDropdownComponent implements OnDestroy {
  savingPreferences = false;
  selectedOption: ETimelineGroup | undefined;

  options = [
    { name: 'Nothing', value: null },
    { name: 'Account', value: ETimelineGroup.ACCOUNT },
    { name: 'Site', value: ETimelineGroup.SITE },
  ];
  private readonly destroy$ = new Subject<void>();

  constructor(
    private timelineGroupService: TimelineGroupService,
    private customTableService: CustomTableService,
    private preferencesService: PreferencesService,
  ) {
    this.selectedOption = this.preferencesService.getPreferences().timeline?.group;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setGrouping(option: { name: string; value: ETimelineGroup }): void {
    if (this.savingPreferences || option.value === this.selectedOption) {
      return;
    }

    this.selectedOption = option.value;
    this.savingPreferences = true;

    this.timelineGroupService
      .setGrouping(option.value)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          this.customTableService.reloadTable();
        }),
        finalize(() => {
          this.savingPreferences = false;
        }),
      )
      .subscribe();
  }
}
